import { render } from "./forgeChangeFrequency.vue?vue&type=template&id=b4a4ca2c"
import script from "./forgeChangeFrequency.vue?vue&type=script&lang=js"
export * from "./forgeChangeFrequency.vue?vue&type=script&lang=js"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__